let Checkbox = require('../checkbox');
let SelectionCount = require('../selection-count');
let cities = require('../../../../../signals/custom-order/cities');

let { cut } = require('../../../../../helpers/utils');
let css = require('./tree.css');
let _ = require('lodash');

let SELECTOR_EXPANDER = cut(css.expandable);
let SELECTOR_BRANCH_BUTTON = cut(css.branchButton);

class Tree {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let root = this.$context.attributes['cat-root'];
        return this.$context.getWatcherData().then((data) => {
            let showNoSelectionMessage = root && data.showSelectedOnly && !_.get(data, 'item.children.length');
            let shouldExpand = root || data.autoExpand || data.expand;
            let isVisible = root || data.showSelectedOnly && data.isSelected || !data.showSelectedOnly;
            let checkboxIdPrefix = this.$context.props.checkboxIdPrefix;
            let isSmallTree = this.$context.props.isSmallTree === 'true';
            return Object.assign({}, data, { root }, {
                shouldExpand,
                isVisible,
                checkboxIdPrefix,
                showNoSelectionMessage,
                isSmallTree
            }, { css });
        });
    }

    bind () {
        return {
            click: {
                [SELECTOR_EXPANDER]: this.switchCollapse,
                [SELECTOR_BRANCH_BUTTON]: this.selectBranch
            }
        };
    }

    switchCollapse (e) {
        e.preventDefault();
        e.stopPropagation();

        let signal = this.$context.props.onSubTreeCollapse;
        let nodeId = this.$context.attributes['cat-id'];
        let basePath = this.$context.props.basePath;
        this.$context.signal(signal, { basePath, nodeId });
    }

    selectBranch (e) {
        e.preventDefault();
        e.stopPropagation();

        let branchId = Number(e.currentTarget.attributes['cat-branch-id'].value);
        let basePath = this.$context.props.basePath;
        this.$context.signal(cities.onBranchCheck, { basePath, branchId, value: true });
    }
}


module.exports = function (basePath) {
    return {
        constructor: Tree,
        children: [
            {
                name: 'tree',
                recursive: true
            },
            {
                name: 'checkbox',
                component: Checkbox,
                watcher (attributes) {
                    let nodeId = attributes['cat-path'];
                    return {
                        value: basePath.concat('selected', nodeId, 'value'),
                        indeterminate: basePath.concat('selected', nodeId, 'indeterminate')
                    };
                },
                props: {
                },
                parentPropsMap: {
                    signal: 'onItemCheck'
                }
            },
            {
                name: 'selection-count',
                component: SelectionCount,
                watcher (attributes) {
                    let nodeId = attributes['cat-path'];
                    return {
                        total: basePath.concat('computed', 'descendantLeafsCount', nodeId),
                        selected: basePath.concat('computed', 'selectedDescendantLeafsCount', nodeId)
                    };
                }
            }
        ]
    };
};



// WEBPACK FOOTER //
// ./components/common/custom-order/filterable-tree/tree/index.js